import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';

// COMPONENTS
import RadioCard from '@/components/Form/RadioCard';

// STYLES
import { TitleContainer, Title, DividerStyled } from '../styles';

const getVariants = stepName => {
  if (stepName === 'agree_device_contract') {
    return [
      { text: 'start.agree_device_contract.variants.yes', value: 'yes' },
      { text: 'start.agree_device_contract.variants.no', value: 'no' },
    ];
  }

  return [
    { text: 'start.device_included.variants.yes', value: 'yes' },
    { text: 'start.device_included.variants.no', value: 'no' },
    { text: 'start.device_included.variants.notSure', value: 'not_sure' },
  ];
};

const DeviceIncluded = ({ values, handleChange, handleBlur, onRadioCardChange, isRequired }) => {
  const [t] = useTranslation();
  const deviceIncludedVariants = getVariants('device_included');
  const contractVariants = getVariants('agree_device_contract');
  // const showContract = values.device_included === 'yes';
  const showContract = false;

  const handleAnswerClick = event => {
    onRadioCardChange(event, handleChange);
  };

  return (
    <>
      <TitleContainer className="form-title">
        <Title
          className={clsx(isRequired && 'required')}
          variant="h4"
          align="center"
          component="h1"
        >
          {t('start.device_included.title')}
        </Title>
        <Typography variant="subtitle1" align="center">
          {t('start.device_included.subtitle')}
        </Typography>
      </TitleContainer>
      <Grid container spacing={1} justifyContent="center">
        {deviceIncludedVariants.map(item => (
          <Grid item xs={6} sm={6} md={3} key={item.value}>
            <RadioCard
              name="device_included"
              text={t(item.text)}
              handleChange={handleAnswerClick}
              handleBlur={handleBlur}
              value={item.value}
              checkedValue={values.device_included}
            />
          </Grid>
        ))}
      </Grid>
      {!showContract ? null : (
        <>
          <DividerStyled />
          <TitleContainer className="form-title">
            <Title
              className={clsx(isRequired && 'required')}
              variant="h4"
              align="center"
              component="h1"
            >
              Danny Test
            </Title>
            <Typography variant="subtitle1" align="center">
              {t('start.agree_device_contract.subtitle')}
            </Typography>
          </TitleContainer>
          <Grid container spacing={1} justifyContent="center">
            {contractVariants.map(item => (
              <Grid item xs={6} sm={6} md={3} key={item.value}>
                <RadioCard
                  name="agree_device_contract"
                  text={t(item.text)}
                  handleChange={handleAnswerClick}
                  handleBlur={handleBlur}
                  value={item.value}
                  checkedValue={values.agree_device_contract}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </>
  );
};

DeviceIncluded.defaultPros = {
  isRequired: false,
};

DeviceIncluded.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  onRadioCardChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
};

export default React.memo(DeviceIncluded);
